
import { Component } from '@angular/core';
import { AuthenticationService } from '../../services/authentication.service';

@Component({
  selector: 'login',
  templateUrl: './login.html',
  styleUrls: ['login.scss'],
})
export class LoginPage {
  model: any = {};
  loading = false;
  error = '';
  redirectUrl: string = '';

  constructor(
    private authenticationService: AuthenticationService,
  ) {}

  login() {
    this.loading = true;

    this.authenticationService.login(this.model.username, this.model.password)
      .then(
        async result => {
          if (result) {
            await this.authenticationService.navigateAfterSuccess();
          } else {
            this.error = 'Username or password is incorrect';
          }

          this.loading = false;
        }
      ).catch(e => {
        this.error = e;
        this.loading = false;
      });
  }
}
